<span class="basic-cell">
  {{ value() | infoDisplay }}
</span>
